import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';

import { DocumentsResponse } from '@/features/case-list/api/types';
import { OneRosterApiTyped } from '@/lib/http.server';
import { standardMiddlewares } from '@/middlewares/standardMiddlewares';

export const getDocumentsDefaultParams = {
  sort: 'title',
  orderBy: 'asc',
  limit: '100',
  offset: '0',
  search: '',
};

const fetchOnerosterDocuments = async (
  onerosterApi: OneRosterApiTyped,
  params: {
    sort?: string;
    limit?: string;
    offset?: string;
    orderBy?: string;
    search?: string;
  }
) => {
  const mergedParams = Object.assign({}, getDocumentsDefaultParams, params);

  const response = await onerosterApi.GET('/ims/case/v1p1/CFDocuments' as any, {
    params: {
      query: {
        sort: mergedParams.sort,
        orderBy: (mergedParams.orderBy ?? 'asc') as 'asc' | 'desc',
        limit: parseInt(mergedParams.limit),
        offset: parseInt(mergedParams.offset),
        search: mergedParams.search ?? '',
      },
    },
  });

  return response.data;
};

type GetDocumentsResponse = {
  data: DocumentsResponse | null;
  success: boolean;
  error: string | null;
};

export const getDocuments = createServerFn({ method: 'POST' })
  .middleware([standardMiddlewares])
  .validator(
    z.object({
      sort: z.string().optional().default(getDocumentsDefaultParams.sort),
      limit: z.string().optional().default(getDocumentsDefaultParams.limit),
      offset: z.string().optional().default(getDocumentsDefaultParams.offset),
      search: z.string().optional().default(getDocumentsDefaultParams.search),
    })
  )
  .handler(async ({ context: { oneRosterApiTyped }, data }) => {
    const response = await fetchOnerosterDocuments(oneRosterApiTyped, data);
    return {
      data: response as any,
      success: true,
      error: null,
    } as GetDocumentsResponse;
  });
